<!-- A/B test screen -->
@if (orderAbTestEnabled) {
  <div class="order-action">
    <div class="icon">
      <svg-inline src="/assets/images/limit-order-icon.svg" alt="image-icon" />
    </div>
    <h2 class="title"> {{ "limit_orders_empty_widget_title_all" | translate }}</h2>
    <p class="subtext"> {{ "limit_orders_empty_widget_description_all" | translate }}</p>
    <div class="btn-container">
      <bp-button
        size="small"
        variant="secondary"
        (click)="createOrder()"
        >{{ "create_limit_order" | translate }}</bp-button
        >
        @if (showCheckOrders) {
          <bp-button size="small" variant="primary" (click)="openOrdersPage()">{{
            "check_all_orders" | translate
          }}</bp-button>
        }
      </div>
    </div>
  } @else {
    <div class="order-action">
      <div class="icon">
        <svg-inline src="/assets/images/limit-order-icon.svg" alt="image-icon" />
      </div>
      <h2 class="title">
        {{
        (pillSelected === sellPillValue
        ? "limit_orders_empty_widget_title_sell"
        : "limit_orders_empty_widget_title"
        ) | translate
        }}</h2
        >
        <p class="subtext">
          {{
          (pillSelected === sellPillValue
          ? "limit_orders_empty_widget_description_sell"
          : "limit_orders_empty_widget_description"
          ) | translate
          }}</p
          >
          <div class="btn-container">
            @if (pillSelected === buyPillValue || isNewSellVisible) {
              <bp-button
                size="small"
                variant="secondary"
                (click)="createOrder(orderType)"
                >{{ (pillSelected === sellPillValue ? "new_sell_order" : "new_buy_order") | translate }}</bp-button
                >
              }
              @if (showCheckOrders) {
                <bp-button size="small" variant="primary" (click)="openOrdersPage()">{{
                  "check_all_orders" | translate
                }}</bp-button>
              }
            </div>
          </div>
        }
